import { ContestTerritoriesService } from "~/entity/ContestTerritories/api/service";

export const useContestTerritories = () => {
  const getContestTerritories =
    ContestTerritoriesService.GET.getContestTerritories;
  const getContestTerritory = ContestTerritoriesService.GET.getContestTerritory;
  const createContestTerritory =
    ContestTerritoriesService.POST.createContestTerritory;
  const updateContestTerritory =
    ContestTerritoriesService.PATCH.updateContestTerritory;
  const getRegions = ContestTerritoriesService.GET.getRegions;

  return {
    getContestTerritories,
    getContestTerritory,
    createContestTerritory,
    updateContestTerritory,
    getRegions,
  };
};
